import { Component, OnInit } from '@angular/core';
import Big from 'big.js';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PosProductDetailModalService } from 'src/app/@core/services/pos-product-detail-modal.service';
import { Filter } from 'src/app/models/filter';
import { FilterTable } from 'src/app/models/filter-table';
import { ProductDetailFilter, ProductFilter } from 'src/app/models/filters/product-filter';
import { Paging } from 'src/app/models/page';
import { Product } from 'src/app/models/product';
import { ProductTableModel } from 'src/app/models/table-models/product-table';
import { Tax } from 'src/app/models/tax';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ProductsService } from 'src/app/services/products.service';
import { SetsService } from 'src/app/services/sets.service';
import { TaxesService } from 'src/app/services/taxes.service';

@Component({
  selector: 'app-pos-products-modal',
  templateUrl: './pos-products-modal.component.html',
  styleUrls: ['./pos-products-modal.component.sass']
})
export class PosProductsModalComponent implements OnInit {

  constructor(public readonly bsModalRef: BsModalRef,
    private readonly productsService: ProductsService,
    private readonly taxesService: TaxesService,
    private readonly setsService: SetsService,
    private readonly configService: ConfigurationService,
    private readonly posProductDetailModalService: PosProductDetailModalService) {


  }

  products: Paging<Array<ProductTableModel>> = new Paging([]);
  private taxes: Array<Tax> = [];
  async ngOnInit(): Promise<void> {
    this.taxes = (
      await this.taxesService.readTaxes().toPromise()
    ).response.content;
    await this.getProductData({ page: 0, pageSize: 5, value: {} });
  }

  confirmAction: (product: ProductTableModel) => any = () => { };

  getProductFilters(): Array<FilterTable> {
    return [
      new FilterTable('text', 'Búsqueda General'),
      new FilterTable('ean', 'EANs'),
      new FilterTable('hasExistence', 'Existencia', { type: 'switch' }),
    ];
  }

  async getProductData(params: Filter<ProductFilter>): Promise<void> {
    let result = (await this.productsService.readProducts(params).toPromise())
      .response;

    this.products = new Paging(
      result.content.map((m) => {
        let model = new ProductTableModel();
        let tax = this.taxes.find((w) => w.code == m.taxCode) || new Tax();
        let price = this.getPriceWithoutTax(m.price.amount, tax);
        return model
          .setCode(m.code)
          .setDescription(m.description)
          .setTotal(m.price.amount)
          .setPrice(price)
          .setStock(m.carStock || 0)
          .setTax(tax.value)
          .setTaxCode(tax.code)
          .setRequiredSerial(m.serialProfile)
          .setFeatures(m.features)
          .setHasWarranty(m.warranty > 0)
          .setServiceType(m.serviceType)
          .setIsService(m.isService)
          .setInvoiceable(m.invoiceable)
          .setWharehouseLocation(m.wharehouseLocation)
          .setWharehouseNumber(m.wharehouseNumber)
          ;
      })
    ).setValues(result);
  }

  async productRowClick(product: ProductTableModel): Promise<void> {
    await this.setSetsData(product);
    this.confirmAction(product);

  }

  private getPriceWithoutTax(price: number, tax: Tax) {
    return Number.parseFloat(
      Big(price)
        .div(Big(1).plus(Big(tax.value).div(100)))
        .toFixed(2)
    );
  }

  cancel() {
    this.bsModalRef.hide();
  }


  private async setSetsData(product: ProductTableModel) {
    let readSetsReponse = await this.setsService.readSetByCodeAndBranch(product.code, this.configService.readSelectedBranchAndSalesOrg().branch.code).toPromise();
    if (readSetsReponse.response.length > 0) {
      const comboSetCorrelative = `${readSetsReponse.response.length + this.random(0, 10000)}`;
      const comboSet = readSetsReponse.response[0];
      product.comboSetProducts = [];
      for (const member of comboSet.members) {
        const filter: ProductDetailFilter = {
          productCode: member.productCode,
          branchCode: this.configService.readSelectedBranchAndSalesOrg().branch.code,
          currentBranchCode: this.configService.readSelectedBranchAndSalesOrg().branch.code,
          hasExistence: false,
          salesOrg: this.configService.readSelectedBranchAndSalesOrg().salesOrg.code
        };
        const productMember = (await (this.productsService.readProduct(filter).toPromise())).response;

        let model = new ProductTableModel();
        let tax = this.taxes.find((w) => w.code == productMember.taxCode) || new Tax();
        let price = this.getPriceWithoutTax(productMember.price.amount, tax);
        model.setCode(productMember.code)
          .setDescription(productMember.description)
          .setTotal(productMember.price.amount)
          .setPrice(price)
          .setStock(productMember.carStock || 0)
          .setTax(tax.value)
          .setTaxCode(tax.code)
          .setRequiredSerial(productMember.serialProfile)
          .setFeatures(productMember.features)
          .setHasWarranty(productMember.warranty > 0)
          .setQuantity(Number(member.quantity))
          .setSetCorrelative(comboSetCorrelative)
          .setComboProduct(product.code)
          .setWharehouseLocation(product.wharehouseLocation)
          .setWharehouseNumber(product.wharehouseNumber)
          ;

        product.comboSetProducts.push(model);
      }

    }
  }

  random(minimo: number, maximo: number): number {
    return Math.floor(crypto.getRandomValues(new Uint32Array(1))[0] * ((maximo + 1) - minimo) + minimo);
  }

  async showDetailProduct(productTableModel: ProductTableModel) {

    let product: Product = (await this.productsService.readProduct({ productCode: productTableModel.code, branchCode: this.configService.readSelectedBranchAndSalesOrg().branch.code, hasExistence: true }).toPromise()).response;
    this.posProductDetailModalService.show(product, () => { });
  }
}
